<template> 
    <!-- 注册、开户、找回密码等应用，宽60rem 内层用 主要使input居中 -->
    <section class="container-two flex-jf-end">
        <div style="width:590px;">
            <slot></slot>
        </div>
    </section>
</template>
<script>
    export default {
        props:[''],
        data(){
            return {

            }
        },
    }
</script>
<style lang="less" scoped>
    section.container-two{
        padding:2.5rem 19.5rem 2.5rem 0;
        // 最后一个 div 的 button , 一般是 ‘下一步’ 或 ‘提交’
        div.btn-box:last-child {
            padding-top:1.5rem;
            text-align: right;
            button{
                width:17.3rem;
            }
        }
        // 条款
        .clause-box{
            width: 29.3rem;
            padding:1rem 0 0 12rem;
            font-size:0.7rem;
            color:#666;
            img{
                width:1rem;
                height:1rem;
                margin-right:.5rem;
            }
            p{
                display: flex;
                line-height:1rem;      
                a{
                    color:#003399;
                }   
            }
            p+p{
                margin-top:.5rem;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/BaseCpts/containerTwo.vue